import { render, staticRenderFns } from "./deleteRoleStaff.vue?vue&type=template&id=1aa28834&scoped=true"
import script from "./deleteRoleStaff.vue?vue&type=script&lang=js"
export * from "./deleteRoleStaff.vue?vue&type=script&lang=js"
import style0 from "./deleteRoleStaff.vue?vue&type=style&index=0&id=1aa28834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa28834",
  null
  
)

export default component.exports